import { useEffect, useState } from 'react';

const STORAGE_KEY = 'twm_phase_shift_later';

/**
 * Persisted "shift later phases" cascade preference (ripple = true, absorb =
 * false) for the multi-phase date editors. Shared by the ProjectDetails
 * schedule editor and the OrderDetails child-order editor and kept in
 * localStorage so the choice survives a refresh / navigation.
 */
export function usePhaseCascadePref(): [boolean, (value: boolean) => void] {
  const [shiftLater, setShiftLater] = useState<boolean>(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, String(shiftLater));
    } catch {
      /* storage unavailable (private mode / quota) — preference just won't persist */
    }
  }, [shiftLater]);

  return [shiftLater, setShiftLater];
}
